/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { useBlogs } from '../utils/blogs';
import BlogVerticalCard from '../components/blog/BlogVerticalCard';
import TitleSection from '../components/common/TitleSection';
import styled from 'styled-components';

const Root = styled.div`
  padding-top: 50px;
`;
const BlogList = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  margin: 60px 0 0 -30px;
  width: calc(100% + 30px);
  & > * {
    flex: 1 1 30.6%;
    max-width: 30.6%;
    margin: 40px 0 0 30px;
    @media (max-width: 768px) {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
`;

function BlogPage() {
  const { isLoading, isError, isSuccess, blogs, error } = useBlogs();

  return (
    <Root>
      <TitleSection title="Blog." caption="Stay updated with our latest news" align="center" />

      {isError ? <p>{error}</p> : null}
      {isLoading ? (
        <p>loading ...</p>
      ) : isSuccess && blogs.length ? (
        <BlogList>
          {blogs.map((blog) => (
            <BlogVerticalCard
              key={blog.slug}
              category={blog.fields.category}
              title={blog.fields.title}
              img={blog.fields.cover_image.fields.file.url}
              slug={blog.fields.slug}
              summary={blog.fields.summary}
            />
          ))}
        </BlogList>
      ) : isSuccess && !blogs.length ? (
        <p>We havent found any blogs yet.</p>
      ) : null}
    </Root>
  );
}

export default BlogPage;
